export default __webpack_public_path__ + "static/media/trafikinfo.55d20d66.png";